import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { flagsFromSession } from '@wix/da-react-context/pkg/flags/helpers';
export var initFlags = createAction("".concat(actionKey, ".INIT_FLAGS"), function (_a) {
    var features = _a.features;
    return ({ flags: flagsFromSession(features) });
});
export var setFlags = createAction("".concat(actionKey, ".SET_FLAGS"), function (flags) { return ({ flags: flags }); });
//# sourceMappingURL=actions.js.map